<div #main>
    <div #topLabel *ngIf="label" class="lab {{labelClass}}">
        {{label}}        
    </div>
    <div #topSpace *ngIf="label" style="height: 3px;"></div>
    <div #inputArea
         class="inputArea"
         [style.background-color]="backgroundColor"
         attr.data-testid="{{testId}}-imgtext-inputArea">
        <table> 
            <tr><ng-container *ngIf="isImgShowing">
                    <td #firstTd><div class="img"></div></td>
                </ng-container>
                    <td>
                        <input #inputCover
                               [style.display]="isEditing?'none':'inline-block'"
                               class="{{fieldClass}}"
                               [ngClass]="{'text-align-right': valueType === 'number'}"
                               readonly="readonly"
                               [width]="inputWidth"
                               [ngModel]="value | callback:getDisplayValue"
                               type="{{isPassword?'password':'text'}}" 
                               placeholder="{{hint | translate}}" 
                               (focus)="handleInputCoverFocus()"
                               (click)="handleInputCoverClick()"
                               attr.data-testid="{{testId}}-imgtext-cover"
                               />
                        <input #input
                               [style.display]="isEditing?'inline-block':'none'"
                               class="{{fieldClass}}"
                               [ngClass]="{'text-align-right': valueType === 'number'}"
                               [width]="inputWidth"
                               attr.maxlength="{{maxlen}}" 
                               [(ngModel)]="value" 
                               type="{{isPassword?'password':'text'}}" 
                               placeholder="{{hint | translate}}" 
                               (change)="onChangeEv($event)" 
                               (input)="onInput()" 
                               (focus)="onFocus()" 
                               (click)="onClick()" 
                               (keypress)="onKeyPress($event)"
                               (blur)="handleBlur($event)"
                               attr.data-testid="{{testId}}-imgtext-input"/> 
                    </td>
                <ng-container *ngIf="isErrorShowing">
                    <td #lastTd><div class="error-img"></div></td>
                </ng-container>
            </tr> 


        </table> 
    </div>
    <div #errorArea *ngIf="isErrorShowing" class="errorArea" [height] = "16">
        {{error}}
    </div>

</div>